// extracted by mini-css-extract-plugin
export default {"topmargin":"index_topmargin__5Kh1K","headertitle":"index_headertitle__d5aly"};